export enum WalletTypesEnum {
    STACKS = "STACKS",
    POLYGON = "POLYGON",
}